/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * Arquivo: src/components/pos/CashMovementModalContent.js
 * Versão: 1.0.0 (NOVO COMPONENTE: MODAL DE MOVIMENTAÇÃO DE CAIXA)
 * Data: 20 de julho de 2025
 * Responsável pela Alteração: Gemini (Arquiteto-Chefe)
 */
import React, { useRef } from 'react';
import { Loader2, DollarSign } from 'lucide-react';

const CashMovementModalContent = ({ type, onSave, isProcessing }) => {
    // Referências para os campos de input dentro do modal.
    // Usamos useRef para acessar os valores diretamente do DOM quando o botão de salvar é clicado.
    const amountRef = useRef(null);
    const descriptionRef = useRef(null);

    // Função para lidar com o salvamento da movimentação de caixa.
    // Ela chama a função 'onSave' passada como prop pelo componente pai (POSPage).
    const handleSave = () => {
        onSave(type, amountRef.current.value, descriptionRef.current.value);
    };

    return (
        <div>
            {/* Parágrafo descritivo para o usuário sobre o tipo de movimentação */}
            <p className="mb-4 text-gray-300">
                Informe o valor e a descrição para {type === 'supply' ? 'o suprimento' : type === 'withdrawal' ? 'a sangria' : 'a despesa'}.
            </p>
            {/* Campo de input para o valor da movimentação */}
            <div className="relative mb-4">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">R$</span>
                <input
                    ref={amountRef} // Associa a referência ao input
                    type="number"
                    placeholder="0.00"
                    autoFocus // Foca automaticamente neste campo ao abrir o modal
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-md focus:ring-brand-gold focus:border-brand-gold text-white"
                />
            </div>
            {/* Campo de input para a descrição da movimentação */}
            <div className="relative mb-6">
                <input
                    ref={descriptionRef} // Associa a referência ao input
                    type="text"
                    placeholder="Descrição da movimentação (ex: lanche, troco, etc.)"
                    className="w-full p-3 bg-gray-800 border border-gray-700 rounded-md focus:ring-brand-gold focus:border-brand-gold text-white"
                    onKeyDown={(e) => { if (e.key === 'Enter') handleSave(); }} // Permite salvar com a tecla Enter
                />
            </div>
            {/* Botão para registrar a movimentação */}
            <button
                onClick={handleSave} // Chama handleSave ao clicar
                disabled={isProcessing} // Desabilita o botão enquanto o processamento está em andamento
                className="w-full flex items-center justify-center p-3 bg-brand-gold text-white font-bold rounded-lg transition-all hover:bg-yellow-600 disabled:bg-gray-600"
            >
                {isProcessing ? <Loader2 className="animate-spin mr-2" /> : <DollarSign className="mr-2" />} Registrar {type === 'supply' ? 'Suprimento' : type === 'withdrawal' ? 'Sangria' : 'Despesa'}
            </button>
        </div>
    );
};

export default CashMovementModalContent;
